import { WithTitle } from "../shared";

import { CustomTable } from "@/components/reusables/data-table/CustomTable";
import { ResponsePagination } from "@/hooks/usePagination";
import { ExtendedColumnDef } from "@/interfaces/globals";
import { IProject } from "@/interfaces/project.interface";

type TProps = {
  projectData: IProject[];
  pagination: ResponsePagination;
};

const columns: ExtendedColumnDef<IProject>[] = [
  {
    accessorKey: "customerName",
    header: "Customer Name",
    cell: ({ row }): React.JSX.Element => {
      const customerName = row.original?.customer?.name || "-";

      return (
        <p
          className='whitespace-nowrap text-wrap uppercase line-clamp-2'
          title={customerName}
        >
          {customerName}
        </p>
      );
    },
  },
  {
    accessorKey: "projectName",
    header: "Project Name",
    meta: {
      classNameRow: "text-ellipsis overflow-hidden",
    },
    cell: ({ row }): React.JSX.Element => {
      return (
        <span
          className='whitespace-nowrap uppercase line-clamp-2 text-wrap'
          title={row.original?.name}
        >
          {row.original?.name ?? "-"}
        </span>
      );
    },
  },
  {
    accessorKey: "projectRefNo",
    header: "Project Ref No",
    cell: ({ row }): React.JSX.Element => {
      return (
        <p className='whitespace-nowrap uppercase'>
          {row.original?.ourReferenceNumber ?? "-"}
        </p>
      );
    },
  },
  {
    accessorKey: "address",
    header: "Address",
    cell: ({ row }): React.JSX.Element => {
      return <p>{row.original?.address?.label ?? "-"}</p>;
    },
  },
];

const ProjectDetails: React.FC<TProps> = ({ projectData, pagination }) => {
  return (
    <section>
      <WithTitle title='Project Details' className='max-w-full p-4 min-w-0'>
        <CustomTable
          title='Project Details'
          columns={columns}
          data={projectData}
          empty={{
            subtitle: "No Project Details Found",
          }}
          id='project-detail'
          hideFilterRow
          functions={{
            pagination,
          }}
          filters={false}
          hide={{
            filters: true,
            functions: true,
          }}
        />
      </WithTitle>
    </section>
  );
};

export default ProjectDetails;
